import { AaGetcaptchaResp } from 'app/bff/models/aa/aaGetcaptcha';
import { AaCaptchaVerifyReq } from 'app/bff/models/aa/aaCaptchaVerify';
import { AaOtpSendcodeReq } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq, AaOtpVerifyResp } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Forget/types';
import { MbSigninResp } from 'app/bff/models/mb/mbSignin';
import { FormValues as AuthFormValues } from 'app/features/Member/Forget/Auth/types';

// State type
export interface ForgetState {
  static: StaticState;
  process: ProcessState;
}

interface StaticState {
  captcha?: AaGetcaptchaResp;
  temporaryAuthorization?: AaOtpVerifyResp;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  auth: {
    data?: AuthFormValues;
    otpAuth: {
      otp?: MbSigninResp;
    };
  };
}
// ::: End

// Actions type constant
export const MEMBER_FORGET__SET_ACCESSIBLE_STEP = 'MEMBER_FORGET__SET_ACCESSIBLE_STEP';
export const MEMBER_FORGET__FETCH_CAPTCHA = 'MEMBER_FORGET__FETCH_CAPTCHA';
export const MEMBER_FORGET__FETCH_CAPTCHA_DONE = 'MEMBER_FORGET__FETCH_CAPTCHA_DONE';
export const MEMBER_FORGET__CHECK_CAPTCHA = 'MEMBER_FORGET__CHECK_CAPTCHA';
export const MEMBER_FORGET__SAVE_AUTH_PAGE_DATA = 'MEMBER_FORGET__SAVE_AUTH_PAGE_DATA';
export const MEMBER_FORGET__SEND_OTP = 'MEMBER_FORGET__SEND_OTP';
export const MEMBER_FORGET__SEND_OTP_DONE = 'MEMBER_FORGET__SEND_OTP_DONE';
export const MEMBER_FORGET__RESEND_OTP = 'MEMBER_FORGET__RESEND_OTP';
export const MEMBER_FORGET__RESEND_OTP_DONE = 'MEMBER_FORGET__RESEND_OTP_DONE';
export const MEMBER_FORGET__AUTH_OTP = 'MEMBER_FORGET__AUTH_OTP';
export const MEMBER_FORGET__SAVE_TEMPORARY_AUTHORIZATION = 'MEMBER_FORGET__SAVE_TEMPORARY_AUTHORIZATION';
export const MEMBER_FORGET__SETUP_NEW_PASS_PHRASE = 'MEMBER_FORGET__SETUP_NEW_PASS_PHRASE';
export const MEMBER_FORGET__UPDATE_CACHE = 'MEMBER_FORGET__UPDATE_CACHE';
export const MEMBER_FORGET__RESET_CACHE = 'MEMBER_FORGET__RESET_CACHE';
// ::: End

// Action creators type
export interface SetAccessibleStepAction {
  type: typeof MEMBER_FORGET__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface FetchCaptchaAction {
  type: typeof MEMBER_FORGET__FETCH_CAPTCHA;
}

export interface FetchCaptchaDoneAction {
  type: typeof MEMBER_FORGET__FETCH_CAPTCHA_DONE;
  payload: {
    response: AaGetcaptchaResp;
  };
}

export interface CheckCaptchaAction {
  type: typeof MEMBER_FORGET__CHECK_CAPTCHA;
  payload: {
    checkCaptchaArgs: AaCaptchaVerifyReq;
    sendOTPArgs: AaOtpSendcodeReq;
    data: AuthFormValues;
  };
}

export interface SaveAuthPageDataAction {
  type: typeof MEMBER_FORGET__SAVE_AUTH_PAGE_DATA;
  payload: {
    data: AuthFormValues;
  };
}

export interface SendOTPAction {
  type: typeof MEMBER_FORGET__SEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
    redirectRoute?: ROUTES;
  };
}

export interface SendOTPDoneAction {
  type: typeof MEMBER_FORGET__SEND_OTP_DONE;
  payload: {
    response: MbSigninResp;
  };
}

export interface ResendOTPAction {
  type: typeof MEMBER_FORGET__RESEND_OTP;
  payload: {};
}

export interface ResendOTPDoneAction {
  type: typeof MEMBER_FORGET__RESEND_OTP_DONE;
  payload: {
    response: MbSigninResp;
  };
}

export interface AuthOTPAction {
  type: typeof MEMBER_FORGET__AUTH_OTP;
  payload: {
    args: AaOtpVerifyReq;
  };
}

export interface SaveTemporaryAuthorizationAction {
  type: typeof MEMBER_FORGET__SAVE_TEMPORARY_AUTHORIZATION;
  payload: {
    authorization: AaOtpVerifyResp;
  };
}

export interface SetupNewPassPhraseAction {
  type: typeof MEMBER_FORGET__SETUP_NEW_PASS_PHRASE;
  payload: {
    args: MbUpdateinfoReq;
  };
}

export interface UpdateCacheAction {
  type: typeof MEMBER_FORGET__UPDATE_CACHE;
  payload: {
    cache: ForgetState;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_FORGET__RESET_CACHE;
}

export type ForgetActions =
    FetchCaptchaAction
  | FetchCaptchaDoneAction
  | CheckCaptchaAction
  | SaveAuthPageDataAction
  | SendOTPAction
  | SendOTPDoneAction
  | ResendOTPAction
  | ResendOTPDoneAction
  | AuthOTPAction
  | SaveTemporaryAuthorizationAction
  | SetupNewPassPhraseAction
  | SetAccessibleStepAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
